import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';
import shadows from 'theme/atoms/shadows';

export const Page = styled.div`
  align-items: center;
  background-color: ${colours.neutral[100]};
  box-sizing: border-box;
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  padding: 20px;
  position: relative;
  width: 100%;

  &::before {
    background-color: rgba(0, 29, 37, 0.3);
    content: '';
    inset: 0;
    pointer-events: none;
    position: absolute;
  }

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-end;
    padding: 60px 0 0 0;
  }
`;

export const InnerPage = styled.div`
  align-items: center;
  background-color: ${colours.shade[0]};
  border-radius: 40px;
  box-shadow: ${shadows.L};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 700px;
  overflow: hidden;
  padding: 20px;
  position: relative;
  width: 100%;
  z-index: 1;

  @media (max-width: ${breakpoints.tablet}) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export default Page;
